import Vue from "vue"
import Router from "vue-router"

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: "/Login",
      name: "Login",
      component: resolve => require(["@/components/login.vue"], resolve)
    },
    {
      path: "/NoPermission",
      name: "NoPermission",
      component: resolve => require(["@/components/nopermission.vue"], resolve)
    },
    {
      path: "/AdminUserManage",
      name: "AdminUserManage",
      component: resolve =>
        require(["@/components/adminmanager/usermanage.vue"], resolve)
    },
    {
      path: "/AdminTeamManage",
      name: "AdminTeamManage",
      component: resolve =>
        require(["@/components/adminmanager/teammanage.vue"], resolve)
    },
    {
      path: "/AdminRoleManage",
      name: "AdminRoleManage",
      component: resolve =>
        require(["@/components/adminmanager/rolemanage.vue"], resolve)
    },
    {
      path: "/AuthList",
      name: "AuthList",
      component: resolve =>
        require(["@/components/adminmanager/authlist.vue"], resolve)
    },
    {
      path: "/AuditLog",
      name: "AuditLog",
      component: resolve =>
        require(["@/components/adminmanager/auditLog.vue"], resolve)
    },
    {
      path: "/AdminUserInfo",
      name: "AdminUserInfo",
      component: resolve =>
        require(["@/components/adminmanager/userinfo.vue"], resolve)
    },
    {
      path: "/AdminTeamInfo",
      name: "AdminTeamInfo",
      component: resolve =>
        require(["@/components/adminmanager/teaminfo.vue"], resolve)
    },
    {
      path: "/AdminInfo",
      name: "AdminInfo",
      component: resolve =>
        require(["@/components/adminmanager/admininfo.vue"], resolve)
    },
    {
      path: "/CommonPersonalInfo",
      name: "CommonPersonalInfo",
      component: resolve =>
        require(["@/components/userInfo/personalinfo.vue"], resolve)
    },
    {
      path: "/CommonPersonalTeam",
      name: "CommonPersonalTeam",
      component: resolve =>
        require(["@/components/userInfo/personalteam.vue"], resolve)
    },
    {
      path: "/CommonTeaminfo",
      name: "CommonTeaminfo",
      component: resolve =>
        require(["@/components/userInfo/teaminfo.vue"], resolve)
    },
    {
      path: "/ProjectList",
      name: "ProjectList",
      component: resolve =>
        require(["@/components/productManage/projectlist.vue"], resolve)
    },
    {
      path: "/ModuleList",
      name: "ModuleList",
      component: resolve =>
        require(["@/components/productManage/modulelist.vue"], resolve)
    },
    {
      path: "/ProjectInfo",
      name: "ProjectInfo",
      component: resolve =>
        require(["@/components/productManage/projectinfo.vue"], resolve)
    },
    {
      path: "/UploadFile",
      name: "UploadFile",
      component: resolve =>
        require(["@/components/softwareManage/uploadfile.vue"], resolve)
    },
    {
      path: "/productionProcessEditor",
      name: "productionProcessEditor",
      component: resolve =>
        require([
          "@/components/softwareManage/productionProcessEditor.vue"
        ], resolve)
    },
    {
      path: "/SoftwareList",
      name: "SoftwareList",
      component: resolve =>
        require(["@/components/softwareManage/softlist.vue"], resolve)
    },
    {
      path: "/upgrade",
      name: "upgrade",
      component: resolve =>
        require(["@/components/softwareManage/upgrade.vue"], resolve)
    },
    {
      path: "/BindSoftware",
      name: "BindSoftware",
      component: resolve =>
        require(["@/components/softwareManage/bindSoftware.vue"], resolve)
    },
    {
      path: "/CreateOrderList",
      name: "CreateOrderList",
      component: resolve =>
        require(["@/components/orderManage/createorderlist.vue"], resolve)
    },
    {
      path: "/qualityOrder",
      name: "qualityOrder",
      component: resolve =>
        require(["@/components/orderManage/qualityOrder.vue"], resolve)
    },
    {
      path: "/orderTracking",
      name: "orderTracking",
      component: resolve =>
        require(["@/components/orderManage/orderTracking.vue"], resolve)
    },
    {
      path: "/PackSoftware",
      name: "PackSoftware",
      component: resolve =>
        require(["@/components/softwareManage/packSoftware.vue"], resolve)
    },
    {
      path: "/DealOrderStep",
      name: "DealOrderStep",
      component: resolve =>
        require(["@/components/orderManage/dealOrderStep.vue"], resolve)
    },
    {
      path: "/OrderList",
      name: "OrderList",
      component: resolve =>
        require(["@/components/orderManage/orderlist.vue"], resolve)
    },
    {
      path: "/CreateProject",
      name: "CreateProject",
      component: resolve =>
        require(["@/components/productManage/createproject.vue"], resolve)
    },
    {
      path: "/hierarchy",
      name: "hierarchy",
      component: resolve =>
        require(["@/components/productManage/hierarchy.vue"], resolve)
    },
    {
      path: "/RelativeSoftList",
      name: "RelativeSoftList",
      component: resolve =>
        require(["@/components/orderManage/relativesoftwarelist.vue"], resolve)
    },
    {
      path: "/SampleList",
      name: "SampleList",
      component: resolve =>
        require(["@/components/sampleManage/samplelist.vue"], resolve)
    },
    {
      path: "/RejectsList",
      name: "RejectsList",
      component: resolve =>
        require(["@/components/sampleManage/rejectslist.vue"], resolve)
    },
    {
      path: "/SampleDetail",
      name: "SampleDetail",
      component: resolve =>
        require(["@/components/sampleManage/sampledetail.vue"], resolve)
    },
    {
      path: "/AddSampleRecord",
      name: "AddSampleRecord",
      component: resolve =>
        require(["@/components/sampleManage/addsamplerecord.vue"], resolve)
    },
    {
      path: "/AddSample",
      name: "AddSample",
      component: resolve =>
        require(["@/components/sampleManage/addsample.vue"], resolve)
    },
    {
      path: "/SearchTestRecord",
      name: "SearchTestRecord",
      component: resolve =>
        require(["@/components/productionManage/searchTestRecord.vue"], resolve)
    },
    {
      path: "/plantManagement",
      name: "plantManagement",
      component: resolve =>
        require(["@/components/productionManage/plantManagement.vue"], resolve)
    },
    {
      path: "/managerList",
      name: "managerList",
      component: resolve =>
        require(["@/components/productionManage/managerList.vue"], resolve)
    },
    {
      path: "/machineList",
      name: "machineList",
      component: resolve =>
        require(["@/components/productionManage/machineList.vue"], resolve)
    },
    {
      path: "/machineTypeManagement",
      name: "machineTypeManagement",
      component: resolve =>
        require([
          "@/components/productionManage/machineTypeManagement.vue"
        ], resolve)
    },
    {
      path: "/machineDetailsList",
      name: "machineDetailsList",
      component: resolve =>
        require([
          "@/components/productionManage/machineDetailsList.vue"
        ], resolve)
    },
    {
      path: "/machineDistribution",
      name: "machineDistribution",
      component: resolve =>
        require([
          "@/components/productionManage/machineDistribution.vue"
        ], resolve)
    },
    {
      path: "/deviceUpgrade",
      name: "deviceUpgrade",
      component: resolve =>
        require(["@/components/productionManage/deviceUpgrade.vue"], resolve)
    },
    {
      path: "/taskdetail",
      name: "taskdetail",
      component: resolve =>
        require(["@/components/productionManage/taskdetail.vue"], resolve)
    },
    {
      path: "/machineCodeAuthorization",
      name: "machineCodeAuthorization",
      component: resolve =>
        require([
          "@/components/productionManage/machineCodeAuthorization.vue"
        ], resolve)
    },
    {
      path: "/deviceManagement",
      name: "deviceManagement",
      component: resolve =>
        require(["@/components/productionManage/deviceManagement.vue"], resolve)
    },
    {
      path: "/scriptManagement",
      name: "scriptManagement",
      component: resolve =>
        require(["@/components/productionManage/scriptManagement.vue"], resolve)
    },
    {
      path: "/orderManagement",
      name: "orderManagement",
      component: resolve =>
        require(["@/components/productionManage/orderManagement.vue"], resolve)
    },
    {
      path: "/logFileAnalysis",
      name: "logFileAnalysis",
      component: resolve =>
        require(["@/components/productionManage/logFileAnalysis.vue"], resolve)
    },
    {
      path: "/AgentManage",
      name: "AgentManage",
      component: resolve =>
        require(["@/components/productionManage/agentManage.vue"], resolve)
    },
    {
      path: "/testFile",
      name: "testFile",
      component: resolve =>
        require(["@/components/softwareManage/testFile.vue"], resolve)
    },
    {
      path: "/TestingJigList",
      name: "TestingJigList",
      component: resolve =>
        require(["@/components/toolManage/testingjiglist.vue"], resolve)
    },
    {
      path: "/record",
      name: "record",
      component: resolve =>
        require(["@/components/toolManage/record.vue"], resolve)
    },
    {
      path: "/Instrumentmanagement",
      name: "Instrumentmanagement",
      component: resolve =>
        require(["@/components/toolManage/Instrumentmanagement.vue"], resolve)
    },
    {
      path: "/apparatusDetails",
      name: "apparatusDetails",
      component: resolve =>
        require(["@/components/toolManage/apparatusDetails.vue"], resolve)
    },
    {
      path: "/AddDramTestingjig",
      name: "AddDramTestingjig",
      component: resolve =>
        require(["@/components/toolManage/addDramTestingjig.vue"], resolve)
    },
    {
      path: "/DramTestingjigDetail",
      name: "DramTestingjigDetail",
      component: resolve =>
        require(["@/components/toolManage/dramTestingjigDetail.vue"], resolve)
    },
    {
      path: "/UKeyManage",
      name: "UKeyManage",
      component: resolve =>
        require(["@/components/toolManage/ukeyList.vue"], resolve)
    },
    {
      path: "/ReportList",
      name: "ReportList",
      component: resolve =>
        require(["@/components/testReportManage/reportList.vue"], resolve)
    },
    {
      path: "/LogManage",
      name: "LogManage",
      component: resolve =>
        require(["@/components/testReportManage/logManage.vue"], resolve)
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.name !== "Login" && !localStorage.userid) {
    localStorage.clear()
    next("Login")
  } else {
    if (!to.name && to.path !== "/") {
      next(false)
    } else if (
      localStorage.defaultactive &&
      to.path === "/"
    ) {
      next(localStorage.defaultactive)
    } else {
      localStorage.setItem('defaultactive', to.name)
      next()
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js